import { render, staticRenderFns } from "./GlobalSidebar.vue?vue&type=template&id=69d207ed"
import script from "./GlobalSidebar.vue?vue&type=script&lang=js"
export * from "./GlobalSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports